import { IChecklist, IPhoto } from './Checklist'
import { ITag } from './Franchise'
import { IPerson } from './Person'

export type PriorityOption = 'Critical' | 'High' | 'Medium' | 'Low'

export interface ITicketTypes {
  ticketTypes: ITicketCategoryType[]
}

export interface ITicketCategoryType {
  id: number
  label: string
  categories: ITicketCategoryMeta[]
}

export enum TicketStatus {
  Pending = 100,
  Open = 200,
  Resolved = 300,
  Closed = 400
}

export interface IPriorityOptionItem {
  value: PriorityOption
  label: string
}

export interface ITicketResolver {
  id: number
  name: string
}
export interface ITicketComment {
  name: string
  date: string
  comment: string
}
export interface ITicketStatus {
  label: string
  value: number | string
}

export interface ITicketCategory {
  id: number
  label?: string
  name?: string
  description?: string
  onlyOneOpener?: boolean
  onlyOneResolver?: boolean // false = all resolvers needed
  onlyOneCloser?: boolean // false = all closers needed
  dueDateReadOnly?: boolean
  templateChecklistId?: number
  checklist?: IChecklist | null
  ticketEntitySetting?: string
  prepopulatingContent?: boolean
  prepopulatingSubject?: boolean
  ticketPopOnly?: boolean
}
export interface ITicket {
  id: number | null
  ticketNo: number
  date: string
  dueDate: string
  status: number
  priority: number
  statusLabel: string
  statusProgress: string
  statusComment?: string
  priorityLabel: string
  subject: string
  content: string
  trackingField?: boolean
  attachments: IPhoto[]
  forFranchisee?: {
    id: number
    name: string
  }
  site?: {
    id: number
    name: string
  }
  sendEmail?: boolean
  emailSentDate?: null | string
  emailTo: string
  cancelTicket?: boolean
  category?: ITicketCategory
  availableStatuses?: ITicketStatus[]
  statusTracker?: ITicketStatus[]
  conversation?: ITicketComment[]
  actionRequired?: {
    label: string
    value: string
  }
  gateKeeper?: {
    resolvers?: ITicketResolver[]
    categoryResolvers?: ITicketResolver[]
  }
  tags?: ITag[]
  franchiseeId: number
  checklist: IChecklist | null
  incidentNo?: number | null
  hazardNo?: number | null
  entityName?: string
  requiredAction?: string
  people?: IPerson[]
  hardAssociation?: boolean
}

export interface IEditTicketFields {
  dueDate: string
  categoryType: string
  category: string
  categoryName?: string
  priority: PriorityOption
  tags: ITag[]
  subject: string
  content: string
  sendEmail: boolean
  emailTo: string
  status: number
  resolverIds: string[]
  statusComment: string
  cancelTicket: boolean
}

export interface ITicketCategories {
  categories: ITicketCategory[]
}

export interface ITicketCategory {
  id: number
  label?: string
  name?: string
  description?: string
  onlyOneOpener?: boolean
  onlyOneResolver?: boolean // false = all resolvers needed
  onlyOneCloser?: boolean // false = all closers needed
  dueDateReadOnly?: boolean
  templateChecklistId?: number
  checklist?: IChecklist | null
  ticketEntitySetting?: string
  prepopulatingContent?: boolean
  prepopulatingSubject?: boolean
  ticketPopOnly?: boolean
}

export interface ITicketCategoryType {
  id: number
  label: string
  categories: ITicketCategoryMeta[]
}

export interface ITicketCategoryMeta {
  id: number
  name: string
}

export interface IStoredTicket {
  localId?: number
  ticketId: number // 0 = not submitted, >0 = submitted ticketId
  franchiseeId: number
  siteId: number
  ticket: ITicket
}

export interface IStoredTicketMeta {
  localId: number
  ticketId: number
  franchiseeId: number
  siteId: number
  ticketNo: number
  subject: string
  categoryId: number
}

export interface ITicketUpdate {
  id: number | null
  dueDate: string
  priorityLabel: string
  status?: number
  subject: string | null
  content: string | null
  emailTo: string
  sendEmail?: boolean
  cancelTicket?: boolean
  tags: ITag[]
  site?: {
    id: number
    name: string
  }
  category?: {
    id: number
  }
  statusComment?: string
  gateKeeper?: {
    resolvers?: ITicketResolver[]
    categoryResolvers?: ITicketResolver[]
  }
  checklist?: IChecklist | null
  people?: IPerson[]
  hardAssociation?: boolean
  incidentNo?: number | null
  hazardNo?: number | null
}

export function convertSelectedResolverIdsToResolvers(
  resolverOptions: ITicketResolver[],
  ids: string[]
): ITicketResolver[] {
  return resolverOptions.filter((resolver) => ids.includes(String(resolver.id)))
}
